import { Divider, Flex, Tooltip, Typography } from 'antd';
import { KeyOutlined } from '@ant-design/icons';
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { DeleteIcon, PencilIcon } from '@/assets/icons/icons';
import SortableRow from '../../DirectContactList/SortableRow';
import type { CredentialListProps } from '../types';

const CredentialList: React.FC<CredentialListProps> = ({
  credentialSets,
  sensors,
  onDragEnd,
  onEditCredential,
  onDeleteCredential,
}) => (
  <DndContext
    sensors={sensors}
    collisionDetection={closestCenter}
    onDragEnd={onDragEnd}
  >
    <SortableContext
      items={credentialSets.map((item) => item.local_key)}
      strategy={verticalListSortingStrategy}
    >
      {credentialSets.map((item, index) => (
        <div key={item.local_key}>
          <SortableRow id={item.local_key} showDrag>
            <KeyOutlined className='sensor-key-icon' />
            <Flex
              vertical
              justify={item.description ? 'flex-start' : 'center'}
              className='sensor-credential-content'
            >
              <Flex
                align='center'
                gap={8}
                className='sensor-credential-title-row'
              >
                <Typography.Text
                  ellipsis={{ tooltip: item.name }}
                  className='sensor-credential-title'
                >
                  {item.name}
                </Typography.Text>
                {index === 0 && (
                  <span className='sensor-primary-badge'>Primary</span>
                )}
              </Flex>
              {item.description && (
                <Typography.Text
                  ellipsis={{ tooltip: item.description }}
                  className='sensor-credential-description'
                >
                  {item.description}
                </Typography.Text>
              )}
            </Flex>
            <Flex gap={2}>
              <Tooltip title='Edit credentials'>
                <button
                  type='button'
                  aria-label='Edit credentials'
                  onClick={() => onEditCredential(index)}
                  className='sensor-icon-button'
                >
                  <span className='sensor-credential-edit-icon'>
                    <PencilIcon
                      width={15}
                      height={15}
                      color='var(--text-primary)'
                    />
                  </span>
                </button>
              </Tooltip>
              <Tooltip title='Delete credentials'>
                <button
                  type='button'
                  aria-label='Delete credentials'
                  onClick={() => onDeleteCredential(index)}
                  className='sensor-icon-button'
                >
                  <DeleteIcon />
                </button>
              </Tooltip>
            </Flex>
          </SortableRow>
          {index < credentialSets.length - 1 && (
            <Divider className='sensor-credential-divider' />
          )}
        </div>
      ))}
    </SortableContext>
  </DndContext>
);

export default CredentialList;
